import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { useBackToTillSummaryEnabled } from './hooks/PickupProvider';
import TenderPickupsTable from './TenderPickupsTable';
import { PATH_END_OF_DAY } from '../../../../constants/routes.const';
import { useGetLocalization } from '../../../../hooks';
import {
  ID_FINAL_PICKUP_TABLE,
  ID_BACK_TO_TILL_SUMMARY_ANCHOR,
} from '../../../../utils/dom-element-ids';
import { ButtonSubmit } from '../../../reusable';

function PickupDeclarationForm({ submit }) {
  const getLocalization = useGetLocalization();
  const { backToTillSummaryEnabled } = useBackToTillSummaryEnabled();
  return (
    <>
      <TenderPickupsTable
        rowsAreOpenable
        id={ID_FINAL_PICKUP_TABLE}
        modalTitle={getLocalization('lbl.till-final-pickup-declaration')}
        submit={submit}
      />
      <br />
      {backToTillSummaryEnabled && (
        <Link
          id={ID_BACK_TO_TILL_SUMMARY_ANCHOR}
          to={{
            pathname: PATH_END_OF_DAY,
          }}
        >
          <ButtonSubmit
            buttonClassName="mb2-sm"
            buttonSize="large"
            label={getLocalization('lbl.back-to-till-summary')}
            sectionClassName="ncss-col-sm-12 full"
            onSubmit={() => {}}
          />
        </Link>
      )}
    </>
  );
}

PickupDeclarationForm.propTypes = {
  submit: PropTypes.func.isRequired,
};
export default PickupDeclarationForm;
